module.exports = __webpack_public_path__ + "img/multiplier_4.850a5441.png";